export default __webpack_public_path__ + "static/media/profilepic.2de33973.jpg";